import { NoteItem } from "../../../components/notes/hooks/state/NoteItem";
import { NoteItemResponse } from "./GetNotesResponse";

type SubjectId = string;

type SubjectNotes = Record<SubjectId, NoteItemResponse[]>;

export type GetNotesBySubjectIdsResponse = SubjectNotes;

export const mapToNoteItem = (response: NoteItemResponse, subjectId: string): NoteItem => ({
    id: response.id,
    author: response.author,
    content: response.content,
    creationDate: response.creationDate,
    subjectId
});
